<template>
  <div class="rescue"
       id="rescue">
    <leftSideBar></leftSideBar>
    <div class="banner">
      <!-- <div class="banner-box">
        <div class="banner-text">
          <h4>紧急救援</h4>
          <p>Emergency</p>
          <p>Assistance</p>
          <h5>广阔世界，伴您同行</h5>
        </div>
      </div> -->
    </div>
    <div class="main"
         style="padding-top: 30px">
      <Breadcrumb class="bread"
                  separator=">">
        <BreadcrumbItem to="/">
          <img class="bread-icon"
               src="../assets/images/icon-location.png" />首页
        </BreadcrumbItem>
        <BreadcrumbItem class="bread-last">全球救援</BreadcrumbItem>
      </Breadcrumb>
      <h4 class="rescue-title"
          style="margin-top:52px;">全球救援服务</h4>
      <div class="service-info">
        <p>北京威马捷国际旅行援助有限责任公司的宗旨是，无论何时何地，在客户有需求时提供安心安全的救助服务。</p>
        <p>紧急医疗救援方面，我们提供的是介绍医院，安排就医，代垫治疗费，安排医疗翻译及重症转运等服务，让我们的客户在全球任何一个区域生病或者受伤时，不受语言环境，就医制度及文化差异的影响，迅速安心地接受治疗。同时我们也提供客户专属的定制医疗救援咨询服务，在客户出发前就当地的医疗环境及医疗水平进行调查， 提供全面具体的健康管理方案以及紧急转运方案，为我们的客户提供一个安心的，完善的医疗救援服务体系。
        </p>
        <p>北京威马捷以《广阔世界，伴您同行》为己任，全年无休的为世界各地的客户提供医疗健康及便利生活的援助服务。</p>
      </div>
      <h4 class="rescue-title">威马捷服务概要</h4>
      <div class="rescue-service-list">
        <!-- <div class="service-cell"
             v-for="(service,index) in services"
             :key="index">
          <span :class="'service0' + (index+1)"></span>
          <div class="service-text">
            <h5>{{service.title}}</h5>
            <p>{{service.info}}</p>
          </div>
        </div> -->
        <img class="service-resource"
             :src="outline"
             alt="">
      </div>
      <!--<h4 class="rescue-title">威马捷全球的业绩和资源</h4>
      <img class="service-resource"
           :src="Resource"
           alt="">-->
      <h4 class="rescue-title">威马捷紧急救援的４大独特资源</h4>
      <a id="sources"></a>
      <div class="resource-list">
        <a v-for="(source,index) in sources"
           :class="['resource-cell',`item${source.id}`]"
           :key="index"
           :id="sources.id">
          <img :src="source.img"
               alt="">
          <h5>{{source.title}}</h5>
          <p>
            <i>{{source.title}}</i>
            <span>{{source.info}}</span>
            <!-- <router-link :to="source.link">查看详情</router-link> -->
            <a @click="toPage(source.link,source.id)">查看详情</a>
          </p>
        </a>
      </div>
      <h4 class="rescue-title">威马捷紧急救援的业务分类</h4>
      <div class="resource-list">
        <a :class="['resource-cell',`item${type.id}`]"
           v-for="(type,index) in types"
           :key="index">
          <img :src="type.img"
               alt="">
          <h5>{{type.title}}</h5>
          <p>
            <i>{{type.title}}</i>
            <span>{{type.info}}</span>
            <a @click="toPage(type.link,type.id)">查看详情</a>
            <!-- <a :to="type.link">查看详情</a> -->
          </p>
        </a>
      </div>
      <h4 class="rescue-title">威马捷合作客户</h4>
      <div class="resource-list cooperation">
        <img :src="customers"
             alt="">
      </div>
    </div>
    <!-- <div class="body-gray">
      <div class="body">
        <div class="title clearfix">
          <span class="title-name name1">友情链接</span>
          <span class="title-english title-gray">LINKS</span>
          <span class="title-note title-gray">友情链接</span>
          <div class="title-line"></div>
        </div>
        <div class="link-content">
          <a class="link-cell cell1"
             target="_blank"
             href="https://www.cn.emb-japan.go.jp">
            <div class="link-text link1">日本驻华大使馆</div>
            <div class="link-text-shadow"></div>
          </a>
          <a class="link-cell cell2"
             target="_blank"
             href="https://emergency.co.jp/">
            <div class="link-text link2">日本威马捷救援株式会社</div>
            <div class="link-text-shadow"></div>
          </a>
          <a class="link-cell cell3"
             target="_blank"
             href="http://www.gwcslife.com/">
            <div class="link-text link3">长生人寿保险有限公司</div>
            <div class="link-text-shadow"></div>
          </a>
          <a class="link-cell cell3"
             target="_blank"
             href="https://medicalexcellencejapan.org/jp/about/">
            <div class="link-text link4">一般社団法人</div>
            <div class="link-text-shadow"></div>
          </a>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
import Resource from '@/assets/images/rescue/service-resource.png';
import outline from '@/assets/images/rescue/outline.jpg';
import resource01 from '@/assets/images/rescue/service-resource01.jpg'
import resource02 from '@/assets/images/rescue/service-resource02.jpg'
import resource03 from '@/assets/images/rescue/service-resource03.jpg'
import resource04 from '@/assets/images/rescue/service-resource04.jpg'
import resource05 from '@/assets/images/rescue/service-resource05.jpg'
import resource06 from '@/assets/images/rescue/service-resource06.jpg'
import resource07 from '@/assets/images/rescue/service-resource07.jpg'
import resource08 from '@/assets/images/rescue/service-resource08.jpg'
import resource09 from '@/assets/images/rescue/service-resource09.jpg'
import resource10 from '@/assets/images/rescue/service-resource10.jpg'
import resource11 from '@/assets/images/rescue/service-resource11.jpg'
import customers from '@/assets/images/rescue/customers.png'
// import record01 from '@/assets/images/rescue/record01.jpg'
// import record02 from '@/assets/images/rescue/record02.jpg'
// import record03 from '@/assets/images/rescue/record03.jpg'
// import record04 from '@/assets/images/rescue/record04.jpg'
import leftSideBar from "@/components/LeftSideBar.vue"
export default {
  data () {
    return {
      outline,
      Resource,
      resource01,
      resource02,
      resource03,
      resource04,
      resource05,
      resource06,
      resource07,
      resource08,
      resource09,
      resource10,
      resource11,
      customers,
      // record01,
      // record02,
      // record03,
      // record04,
      services: [
        { title: '24HX365天中·日·英·韩等多语言对应呼叫', info: '24HX365天提供服务的救援呼叫中心。10年以上医疗援助经验的客服人员。' },
        { title: '第二诊疗意见', info: '根据客户需求可由顾问医生根据海外治疗情况给出建议。' },
        { title: '安排就医', info: '根据客户需求安排最合适的医疗机构就医。' },
        { title: '医疗转运及安排归国就医', info: '协助客户联系归国就医医院，安排归国转运，提供病床到病床的一站式医疗转运服务。' },
        { title: '医疗费的挂账及代垫支付', info: '在位医疗费挂账的同时进行减额教师并代垫支付。根据客户需要提供最少个人负担的保险使用建议。' },
        { title: '遗体处理及送返', info: '协助客户办理当地遗体处理手续并安排遗体送返。' },
        { title: '电话翻译服务', info: '利用三方通话，由客服人员提供电话医疗翻译。' },
        { title: '海外医疗费减额手续代理', info: '美英等高额治疗费国家就医时的减额交涉代理。' },
        { title: '安排就医.协助就诊.医疗管理', info: '在需要就医时，威马捷向会员提供所在地的医院、医生的名称、地址和电话，被保险人根据自己的需要自主选择医疗机构就医。实时把控现地治疗信息，并对治疗费进行管理。' },
        { title: '非医疗救援', info: '为保险公司银行的会员提供旅行援助及生活管家等服务' },
      ],
      sources: [
        { id: '1', img: resource01, title: '专业的救援客服中心', link: '/rescueOfCustomerService', info: '24H×365天提供服务的救援呼叫中心。 10年以上医疗援助经验的客服人员。 中，英，日，韩等多国语言对应。 专业的呼叫中心电话系统及案件管理系统' },
        { id: "2", img: resource02, title: '广泛的全球合作网络', link: '/rescueOfWorldNet', info: '在中国，北京总公司以外，上海，大连，广州分公司配有医疗翻译陪同人员24小时为客户提供服务。同时联合集团公司EAJ的全球救援基地（日本东京，泰国，新加坡，美国，英国，加拿大），通过全球合作医院超过1万的自有供应商网络，为客户的安心之旅保驾护航。' },
        { id: "3", img: resource03, title: '丰富的医疗转运经验', link: '/rescueOfExpericence', info: '通过近20年，2000多件国际医疗转运案件的经验积累，专业解析转运路线及方法做成的自有的救援地图服务系统，为重症患者提供迅速并专业的就医及转运方案。' },
        { id: "4", img: resource04, title: '个性化定制救援服务', link: '/rescueOfPersonalized', info: '根据客户需求，对指定的特定地区展开前期医疗调查，量身定做就医及重症转运方案，派遣医疗人员进驻，为客户在当地的业务展开提供安心的医疗援助保障。' },
      ],
      types: [
        { id: "5", img: resource05, title: '在华紧急救援服务', link: '/rescueOfEmergencyInChina', info: '日本及海外保险公司及救援公司委托的在华救援服务。' },
        { id: "6", img: resource06, title: '境外紧急救援服务', link: '/rescueOfOverseasService', info: '中国保险公司及救援公司委托的境外救援服务。' },
        { id: "7", img: resource07, title: '企业法人会员服务', link: '/rescueOfMemberService', info: '威马捷为驻扎海外及出差的会员提供医疗救援服务。服务内容不只有紧急事故发生时的就诊及紧急转运安排，医疗翻译和治疗费垫付服务，还包括前期进行的信息收集和境外体检预约，以及医疗转运和归国后的医院安排等配套服务。无论保险是否能够理赔，从预防保健到治疗后的关怀，威马捷全面地为会员提供援助服务，保障安心。' },
        { id: "8", img: resource08, title: '定制救援服务', link: '/rescueOfPersonalized', info: '由专业医护人员为在海外驻地及工厂工作的会员提供健康管理咨询、紧急救援及安全指导等服务。具体包括，工作环境及现地医疗状况的调查并提供信息，意外伤害或疾病发生时的紧急救助，以及心肺复苏等急救知识的实操讲解和精神压力咨询等个人健康教育管理的服务。' },
        { id: "9", img: resource09, title: '紧急重症救援', link: '/rescueOfIndividualCase', info: '针对非会员客户（企业或者个人）委托的个案，而提供的紧急救援（医疗转运，或者遗体转运）服务。' },
        { id: "10", img: resource10, title: '其他旅行援助', link: '/rescueOfOtherService', info: '协助客户就飞机延误，行李延误，行李破损，损害赔偿等非医疗事故进行理赔。' },
        // {img:resource11, title: '威马捷健康管理俱乐部',link: '/rescueOfGlobalClub', info: '威马捷健康管理俱乐部为服务更多的全球出行人员，将公司三大优势资源有机整合后，以全球紧急救援服务卡的形式回馈给新老客户。'},
      ]
    }
  },
  components: {
    leftSideBar
  },
  // mounted () {
  //   let fromPath = localStorage.getItem('fromPath')
  //   if (fromPath.includes('rescueOf')) {
  //     let id = localStorage.getItem('RescueScrollTop')
  //     // alert(id)
  //     let elm = document.querySelector('.item' + id)
  //     elm.scrollIntoView(true)
  //     localStorage.setItem('fromPath', '')
  //   } else {
  //     localStorage.setItem('RescueScrollTop', '')
  //     localStorage.setItem('fromPath', '')
  //     this.$nextTick(() => {
  //       window.scrollTo(0, 0);
  //     })
  //   }
  // },
  methods: {
    toPage (path, id) {
      // alert(id)
      localStorage.setItem('RescueScrollTop', id)
      const { href } = this.$router.resolve({
        path: path
      })
      window.open(href, '_blank');
    }
  }
}
</script>
<style lang="less">
.rescue {
  background: #fff;
  overflow: hidden;
}
.rescueBread {
  margin: 30px 0;
}
.rescue-title {
  position: relative;
  font-size: 24px;
  line-height: 23px;
  padding-bottom: 15px;
  font-weight: bold;
  color: #333130;
  /*border-bottom: 3px solid #ae1e10;*/
  margin-bottom: 40px;
  padding-top: 20px;
  &::after {
    position: absolute;
    left: 0;
    bottom: 0;z
    display: block;
    content: '';
    width: 100%;
    height: 4px;
    background-size: 100%;
    /*background: #ae1e10;*/
    background-image: url('../assets/images/line.gif');
  }
}
.rescue-bigtitle {
  position: relative;
  width: 100%;
  height: 80px;
  background: url('../assets/images/title-bg.png') no-repeat center center;
  background-size: 100% 100%;
  color: #fff;
  font-size: 28px;
  line-height: 80px;
  padding-left: 45px;
  margin-bottom: 60px;
}
.experience-para {
  width: 906px;
  color: #333130;
  font-size: 24px;
  line-height: 36px;
  margin: 0 auto;
}
.experience-part {
  border: 2px solid #e9ebf4;
  padding: 20px 0 30px;
  margin-bottom: 35px;
}
.experience-smalltitle {
  position: relative;
  width: 906px;
  font-size: 24px;
  color: #333130;
  line-height: 28px;
  text-indent: 20px;
  margin: 36px auto;
  &::before {
    position: absolute;
    left: 0;
    top: 8px;
    content: '';
    display: block;
    width: 12px;
    height: 12px;
    background: #333130;
    border-radius: 6px;
  }
}
.personalized-list {
  display: flex;
  width: 906px;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
  .personal-cell {
    width: 424px;
    height: 240px;
    border: 1px solid #e9ebf4;
    padding: 12px;
    margin-bottom: 30px;
    h5 {
      font-size: 24px;
      color: #ae1e10;
      line-height: 52px;
      margin-bottom: 32px;
      font-weight: normal;
    }
    p {
      font-size: 20px;
      color: #333130;
      line-height: 36px;
    }
    &:hover {
      h5 {
        top: 0;
      }
    }
  }
}
.more-case {
  display: block;
  position: relative;
  font-size: 22px;
  color: #4b4949;
  line-height: 30px;
  padding-left: 34px;
  margin: 40px 0 60px;
  &::before {
    position: absolute;
    left: 0;
    top: 0;
    content: '';
    display: inline-block;
    width: 24px;
    height: 24px;
    background: #ea2929;
    border-radius: 12px;
  }
}
.rescue-flex {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
}
.rescue-img {
  width: 100%;
}
</style>
<style lang="less" scoped>
.banner {
  position: relative;
  width: 1440px;
  height: 345px;
  margin: auto;
  background: url('../assets/images/home/banner-3.jpg') no-repeat center;
  background-size: 100% auto;
  .banner-box {
    width: 944px;
    margin: auto;
    .banner-text {
      width: 430px;
      height: 345px;
      padding: 54px 0 54px 54px;
      box-sizing: border-box;
      background: rgba(255, 255, 255, 0.5);
      h4 {
        font-size: 69px;
        color: #ea2612;
        margin-top: 5px;
      }
      p {
        font-size: 36px;
        color: #fff;
      }
      h5 {
        color: #484848;
        font-size: 36px;
        margin-top: 15px;
        font-weight: 600;
      }
    }
  }
}

.service-info {
  margin: 28px 0 78px;
  p {
    font-size: 16px;
    color: #333130;
    line-height: 36px;
    margin-bottom: 36px;
  }
}
.rescue-service-list {
  width: 934px;
  margin: 0 auto 131px auto;
  img {
    width: 934px;
    display: block;
  }
}
.service-resource {
  width: 932px;
  margin: 0 auto 143px auto;
  display: block;
}
.resource-list {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 70px;

  .resource-cell {
    position: relative;
    width: 466px;
    height: 323px;
    background: #fff;
    border: 1px solid #f1f1f1;
    margin-bottom: 28px;
    overflow: hidden;
    img {
      position: absolute;
      top: 0;
      bottom: 0;
      width: 100%;
      height: 323px;
    }
    h5 {
      display: block;
      position: absolute;
      bottom: 0;
      width: 467px;
      height: 56px;
      background: rgba(0, 0, 0, 0.7);
      font-size: 24px;
      color: #ffffff;
      line-height: 56px;
      text-align: center;
      transition: 0.5s;
    }
    p {
      position: absolute;
      bottom: 0px;
      font-size: 14px;
      color: #3a3a3a;
      line-height: 26px;
      width: 467px;
      height: 0px;
      color: #ffffff;
      background: rgba(0, 0, 0, 0.7);
      padding: 0px 60px;
      box-sizing: border-box;
      overflow: hidden;
      animation: boxBottom 0.5s;
      i {
        font-size: 24px;
        display: block;
        font-style: normal;
        text-align: center;
        margin-bottom: 26px;
      }
      span {
        font-size: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 5;
        -webkit-box-orient: vertical;
      }
      a {
        width: 120px;
        height: 40px;
        border: 1px solid #fff;
        font-size: 18px;
        border-radius: 1px;
        line-height: 40px;
        color: #fff;
      }
    }
    a {
      display: block;
      width: 170px;
      height: 56px;
      border: 1px solid #ae1e10;
      color: #ae1e10;
      font-size: 24px;
      line-height: 56px;
      text-align: center;
      margin: 30px auto 0 auto;
    }
    &:hover {
      h5 {
        background: rgba(0, 0, 0, 0);
        height: 0;
        transition: 0.5s;
      }
      p {
        bottom: 0;
        height: 323px;
        padding: 40px 60px;
        animation: boxTop 0.5s;
      }
    }
  }
}
.cooperation {
  a {
    width: 120px;
    height: 40px;
    background: rgba(222, 228, 239, 1);
  }
  img {
    width: 100%;
  }
}
.record-list {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 30px 0;
  img {
    width: 317px;
    height: 170px;
  }
}
.record-line {
  width: 100%;
}
.body-gray {
  background: #f6f6f6;
}
.body {
  width: 970px;
  overflow: hidden;
  margin: 0 auto;
}
.title {
  position: relative;
  margin: 50px 0;
}
.title-name {
  float: left;
  font-size: 26px;
  color: #333130;
  line-height: 30px;
  padding-left: 40px;
}
.title-line {
  width: auto;
  height: 1px;
  background-color: #d8d8d8;
  margin-left: 150px;
  margin-top: -2px;
}
.title-english {
  position: relative;
  display: inline-block;
  font-size: 16px;
  color: #898888;
  line-height: 20px;
  padding: 0 26px;
  margin-top: 10px;
  margin-left: 30px;
}
.title-white {
  background: #fff;
}
.title-gray {
  background: #f6f6f6;
}
.title-english::before {
  position: absolute;
  left: 4px;
  bottom: 0;
  display: inline-block;
  content: '';
  width: 1px;
  height: 16px;
  background: #8a8988;
  transform: rotateZ(45deg);
}
.title-english::after {
  position: absolute;
  right: 4px;
  bottom: 0;
  display: inline-block;
  content: '';
  width: 1px;
  height: 16px;
  background: #8a8988;
  transform: rotateZ(45deg);
}
.title-note {
  position: absolute;
  right: 0;
  bottom: 0;
  display: inline-block;
  font-size: 14px;
  color: #b2b3b3;
  line-height: 20px;
  padding-left: 6px;
  padding-right: 16px;
}
.title-note::after {
  position: absolute;
  right: 0;
  bottom: 2px;
  display: inline-block;
  content: '';
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background: #d9d9d9;
}
.link-content {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 80px;
  .link-cell {
    position: relative;
    width: 450px;
    height: 110px;
    background: #fff;
    border: 1px solid #d6d6d6;
    margin-bottom: 34px;
    // transition: 0.5s linear;
    .link-text {
      position: absolute;
      right: 0;
      top: 20px;
      z-index: 3;
      width: 338px;
      height: 50px;
      font-size: 22px;
      color: #fff;
      line-height: 50px;
      text-align: center;
      transition: 0.3s linear;
    }
    .link-text-shadow {
      position: absolute;
      right: 0;
      top: 32px;
      z-index: 1;
      display: block;
      width: 352px;
      height: 50px;
      background: #d8d8d8;
    }
    .link1 {
      background: #ae1e10;
    }
    .link2 {
      background: #3c4c7e;
    }
    .link3 {
      background: #585858;
    }
    .link4 {
      background: #7c6f41;
    }
  }
  .link-cell:hover .link-text {
    width: 352px;
    transform: translateY(14px);
    transform-origin: right bottom;
    transition: 0.3s linear;
  }
  .cell1 {
    background: #fff url('../assets/images/home/icon-link1.png') no-repeat 20px
      22px;
  }
  .cell2 {
    background: #fff url('../assets/images/home/icon-link2.png') no-repeat 20px
      22px;
  }
  .cell3 {
    background: #fff url('../assets/images/home/icon-link3.png') no-repeat 20px
      22px;
  }
}
@-webkit-keyframes boxTop {
  0% {
    bottom: 0px;
    height: 0;
    padding: 0px 60px;
  }
  100% {
    bottom: 0px;
    height: 323px;
    padding: 40px 60px;
  }
}
@-webkit-keyframes boxBottom {
  0% {
    bottom: 0px;
    height: 323px;
    padding: 40px 60px;
  }
  100% {
    bottom: 0px;
    height: 0;
    padding: 0px 60px;
  }
}
</style>